<template>
    <section class="dashboard-component suggested-packages-list" v-if="packages.length">
        <heading colour="white" size="medium" no-margin>Suggested Projects</heading>
        <p>Here is a list of projects that might be relevant to you.</p>
        <div class="scroll-it">
            <div v-for="packageStatusList in packages">
                <h2>{{ packageStatusList[0].status.name }}</h2>
                <ul>
                    <li v-for="packageItem in packageStatusList">
                        <a :href="packageItem._links.frontend.view">{{ packageItem.name }}</a>
                    </li>
                </ul>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        components: {},
        data() {
            return {
                packages: []
            }
        },
        computed: {},
        watch: {},
        methods: {
            getPackages() {
                var that = this;
                this.packages = [];

                axios.get(appUrls.packages.suggested)
                    .then(response => {
                        that.packages = _.groupBy(response.data.data, function (pack) {
                            return pack.status.id;
                        });
                    });
            }
        },
        mounted() {
            this.getPackages();
        }
    }
</script>

<style lang="scss" scoped>
    .scroll-it{
        max-height:400px;
        overflow-x:scroll;
        -webkit-overflow-scrolling: touch;
    }

    h2 {
        font-size: 16px;
    }

    ul {
        margin-bottom: 1em;
    }

    a {
        text-decoration: none;
        color: $brand;
        transition: all 0.1s ease-in-out;
        &:hover {
            color: lighten($brand, 10);
        }
    }
</style>
